import { onMounted, onUnmounted, unref } from 'vue'

export const usePoll = (pollFn, { interval, immediate = false }) => {
  let timer = null
  let enabled = false

  const onVisibilityChange = () => {
    if (document.hidden) {
      console.log('⏰ document hidden')
      stopPolling()
    } else {
      console.log('⏰ documen revealed')
      startPolling({ startImmediately: true })
    }
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', onVisibilityChange)
  })

  onUnmounted(() => {
    stopPolling()
    document.removeEventListener('visibilitychange', onVisibilityChange)
  })

  const startPolling = ({ startImmediately = false } = {}) => {
    if (!enabled) {
      return
    }

    console.log('⏰ start poll')

    if (startImmediately) {
      pollFn()
    }

    if (timer) {
      clearTimeout(timer)
    }

    const next = async () => {
      timer = setTimeout(async () => {
        await pollFn()
        if (enabled) {
          next()
        }
      }, unref(interval))
    }

    next()
  }

  const stopPolling = () => {
    console.log('⏰ stop poll')
    if (timer) {
      clearTimeout(timer)
    }
  }

  const stop = () => {
    console.log('⏰ stopping poll')
    enabled = false
    stopPolling()
  }

  const start = () => {
    console.log('⏰ starting poll')
    enabled = true
    startPolling({ startImmediately: immediate })
  }

  return {
    start,
    stop
  }
}
